<template>
  <div class="view">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        :exact="true"
        :to="{ name: 'requirement', params: {} }"
      >
        Requirement
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :to="{ name: 'requirementView', params: {} }">
        View Requirement
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card v-if="loaded">
      <v-card-title>
        View Requirement
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr v-if="requirement.name">
                <td class="text-subtitle-1">Name:</td>
                <td>{{ requirement.name }}</td>
              </tr>

              <tr v-if="requirement.description">
                <td class="text-subtitle-1">Description:</td>
                <td>{{ requirement.description }}</td>
              </tr>

              <tr v-if="requirement.type">
                <td class="text-subtitle-1">
                  Requirement Type:
                </td>
                <td>
                  {{ requirement.type }}
                  <span v-if="requirement.formId">(Online Form {{requirement.formId}})</span>
                </td>
              </tr>

              <tr v-if="requirement.target">
                <td class="text-subtitle-1">
                  Targeted Group:
                </td>
                <td>
                  {{ getRelationText(requirement.target, "target", "name") }}
                </td>
              </tr>

              <tr v-if="requirement.required">
                <td class="text-subtitle-1">Required:</td>
                <td>{{ requirement.required ? 'Yes':'No' }}</td>
              </tr>

              <tr v-if="requirement.attachmentRequired">
                <td class="text-subtitle-1">Require Proof:</td>
                <td>{{ requirement.attachmentRequired ? 'Yes':'No'}}</td>
              </tr>

              <tr v-if="requirement.originalRequired">
                <td class="text-subtitle-1">Original Document Required:</td>
                <td>{{ requirement.originalRequired ? 'Yes':'No' }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-subheader v-if="ruleVaccination">
          Vaccination rules:
        </v-subheader>
        <v-simple-table v-if="ruleVaccination">
          <template v-slot:default>
            <tbody>
              <tr v-if="ruleVaccination.multipleDose">
                <td class="text-subtitle-1">Multiple Doses:</td>
                <td>{{ ruleVaccination.multipleDose ? 'Yes':'No' }}</td>
              </tr>

              <tr v-if="ruleVaccination.annually">
                <td class="text-subtitle-1">Annually:</td>
                <td>{{ ruleVaccination.annually }}</td>
              </tr>

              <tr v-if="ruleVaccination.minAgeYear || ruleVaccination.minAgeMonth">
                <td class="text-subtitle-1">Starting Age:</td>
                <td>{{ ruleVaccination.minAgeYear }} years {{ruleVaccination.minAgeMonth }} months</td>
              </tr>

              <tr v-if="ruleVaccination.doseCount">
                <td class="text-subtitle-1">Dose Count:</td>
                <td>{{ ruleVaccination.doseCount }}</td>
              </tr>

              <tr v-if="ruleVaccination.doseSchedules">
                <td class="text-subtitle-1">
                  Time between Doses:
                </td>
                <td>
                  <div class="my-2" v-for=" (schedule, index) in ruleVaccination.doseSchedules" :key="index">{{schedule.timeNextDose}} {{schedule.timeNextDoseUnit}} between dose {{index +1}} and dose {{index +2}}</div>
                </td>
              </tr>

            </tbody>
          </template>
        </v-simple-table>

        <v-subheader v-if="ruleCertification">
          Certification rules:
        </v-subheader>
        <v-simple-table v-if="ruleCertification">
          <template v-slot:default>
            <tbody>
              <tr v-if="ruleCertification.type">
                <td class="text-subtitle-1">Type:</td>
                <td>{{ ruleCertification.type }}</td>
              </tr>

              <tr v-if="ruleCertification.validationPeriod">
                <td class="text-subtitle-1">Valid Period:</td>
                <td>{{ ruleCertification.validationPeriod }}</td>
              </tr>

              <tr v-if="ruleCertification.validationPeriodUnit">
                <td class="text-subtitle-1">
                  Validation Period:
                </td>
                <td>{{ ruleCertification.validationPeriodUnit }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <attachments-view v-model="requirement.attachments"/>

      </v-card-text>
    </v-card>

    <div class="d-flex justify-space-between ma-5">
      <v-btn @click="goBack">Back</v-btn>
      <v-btn @click="edit(id)" color="primary">Edit</v-btn>
      <span></span>
    </div>
  </div>
</template>

<script>
import { getRequirement } from "@/services/requirement";

import { getAllContactTypes } from "@/services/contactType";
import AttachmentsView from '../common/AttachmentsView.vue';

export default {
  data() {
    return {
      id: "",
      requirement: {},
      loaded: false,
      relations: {}
    };
  },
  computed: {
    ruleVaccination() {
      return this.requirement.ruleVaccination;
    },
    ruleCertification() {
      return this.requirement.ruleCertification;
    }
  },
  components: { AttachmentsView },
  methods: {
    goBack() {
      // this.$router.go(-1);
      this.$router.push({ name: "requirement" });
    },
    edit(id) {
      this.$router.push({ name: "requirementEdit", params: { id: id } });
    },
    setInstance() {
      this.setDependencies().then(() => {
        getRequirement(this.id)
          .then(response => {
            this.requirement = response.data;
            
            if(this.requirement.attachments){
              this.requirement.attachments.forEach(file => {
                const path = `${process.env.VUE_APP_BASE_URL}/compliance/requirement/attachment/${file.id}`;
                file.path = path;
              })
            }
            this.loaded = true;
          })
          .catch(() => {
            this.addErrorMessage("Error loading requirement");
            this.loaded = true;
          });
      });
    },
    async setDependencies() {
      const params_target = {
        page: 0,
        size: 100
      };
      await getAllContactTypes(params_target).then(response => {
        this.relations.target = response.data.content;
        return this.relations.target;
      });
    },
    getRelationText(id, relationProperty, relationAttribute) {
      const relationList = this.relations[relationProperty];
      if (relationList) {
        const relationObj = relationList.find(r => r.id == id);
        return relationObj ? relationObj[relationAttribute]:'';
      } else {
        return "";
      }
    },
    setRequirementRules() {}
  },
  created() {
    this.id = this.$route.params.id;
    this.setInstance();
    this.$emit("showParent", false);
  }
};
</script>

<style scoped>
table > tbody > tr > td:first-child {
  width: 200px;
}
</style>